import React, { memo } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';

import SubmitBtn from '@/pages/reservation/roomExchange/components/SubmitBtn';
import { createStateSelector } from '@/redux/actions/reservation/helper';
import { ReducerState, storeName } from '@/redux/reducers/reservation/checkInExchange';

const stateSelector = (state: ReducerState) => {
  const { rentRoomInfos, marketPriceList, rentTimeInfo, storeRemarks } = state;
  return { rentRoomInfos, marketPriceList, rentTimeInfo, storeRemarks };
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;
interface IProps {
  onSubmit: () => void;
}

const Index: React.FC<IProps & MapStateProps & MapDispatchProps> = (props) => {
  const { onSubmit, rentRoomInfos, marketPriceList, storeRemarks } = props;

  return (
    <SubmitBtn
      btnText={intl.get('drawer_exchange_checkin_submit_btn')}
      onSubmit={onSubmit}
      rentRoomInfos={rentRoomInfos}
      marketPriceList={marketPriceList}
      storeRemarks={storeRemarks}
    />
  );
};

export default connect<MapStateProps, MapDispatchProps, IProps>(
  mapStateToProps,
  mapDispatchToProps,
)(memo(Index));
